import { UnhandledBehaviorError } from "../util/exception";
import { ModuleProduct } from "./ModuleProduct";
import { Vegemite } from "./products/Vegemite";

export default async function moduleResolver(moduleName: string): Promise<ModuleProduct> {
    if (moduleName === "Vegemite") {
        return new Vegemite();
    }
    throw new UnhandledBehaviorError(`Failed to resolve Module, Module ${moduleName} not found`);
}
